(function () {
  function resetBtn(btn) {
    btn.textContent = 'ADD';
    btn.disabled = false;
    btn.style.background = '';
    btn.style.borderColor = '';
    btn.style.color = '';
  }

  function refreshCartDOM() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var sel = [
            ['#CartDrawer-CartItems', 'innerHTML'],
            ['.totals__total-value', 'innerHTML']
          ];
          sel.forEach(function (pair) {
            var fresh = doc.querySelector(pair[0]);
            var current = document.querySelector(pair[0]);
            if (fresh && current) current[pair[1]] = fresh[pair[1]];
          });
          var newSav = doc.querySelector('.cart-drawer__savings');
          var curSav = document.querySelector('.cart-drawer__savings');
          if (newSav && curSav) curSav.outerHTML = newSav.outerHTML;
          else if (newSav && !curSav) {
            var totals = document.querySelector('.totals');
            if (totals) totals.insertAdjacentElement('afterend', newSav);
          } else if (!newSav && curSav) curSav.remove();

          var newUp = doc.querySelector('#cart-upsell-widget');
          var curUp = document.getElementById('cart-upsell-widget');
          if (newUp && curUp) curUp.outerHTML = newUp.outerHTML;
          else if (!newUp && curUp) curUp.remove();
        } catch (e) {}
      })
      .catch(function () {});
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        var el = document.querySelector('.cart-count-bubble span');
        if (el) el.textContent = cart.item_count;
      })
      .catch(function () {});
  }

  // ── CLICK — uses delegation so works after any DOM refresh ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-upsell__button');
    if (!btn) return;
    if (btn.disabled) return;

    var widget = btn.closest('#cart-upsell-widget');
    var select = widget ? widget.querySelector('.cart-upsell__select') : null;
    var variantId = select ? select.value : null;
    if (!variantId) return;

    btn.textContent = 'Adding...';
    btn.disabled = true;

    var safetyTimer = setTimeout(function () { resetBtn(btn); }, 6000);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('failed');
        return res.json();
      })
      .then(function () {
        clearTimeout(safetyTimer);
        btn.textContent = '✓ Added!';
        btn.style.background = '#1e5e21';
        btn.style.borderColor = '#1e5e21';
        setTimeout(function () { resetBtn(btn); }, 2000);
        updateCartCount();
        refreshCartDOM();
      })
      .catch(function () {
        clearTimeout(safetyTimer);
        btn.textContent = 'Try Again';
        btn.disabled = false;
        setTimeout(function () { resetBtn(btn); }, 2000);
      });
  });

  // ── SELECT CHANGE — delegation so works after any DOM refresh ──
  document.addEventListener('change', function (e) {
    var select = e.target.closest('.cart-upsell__select');
    if (!select) return;

    var widget = select.closest('#cart-upsell-widget');
    var img = widget ? widget.querySelector('#upsell-product-image') : null;
    var opt = select.options[select.selectedIndex];
    var newSrc = opt ? opt.getAttribute('data-image') : null;

    if (newSrc && img) {
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = newSrc;
        img.style.opacity = '1';
      }, 150);
    }
  });
})();
